export default function TrustBadgeSection() {
  const paymentMethods = [
    {
      icon: "ri-visa-line",
      label: "Visa",
      color: "text-indigo-600",
      bg: "bg-indigo-50",
    },
    {
      icon: "ri-mastercard-line",
      label: "Mastercard",
      color: "text-orange-500",
      bg: "bg-orange-50",
    },
    {
      icon: "ri-bank-card-2-line",
      label: "银联",
      color: "text-red-500",
      bg: "bg-red-50",
    },
    {
      icon: "ri-wechat-pay-line",
      label: "微信支付",
      color: "text-green-600",
      bg: "bg-green-50",
    },
    {
      icon: "ri-alipay-line",
      label: "支付宝",
      color: "text-sky-500",
      bg: "bg-sky-50",
    },
    {
      icon: "ri-paypal-line",
      label: "PayPal",
      color: "text-sky-700",
      bg: "bg-sky-50",
    },
    {
      icon: "ri-secure-payment-line",
      label: "借记卡",
      color: "text-teal-600",
      bg: "bg-teal-50",
    },
  ];

  const trustItems = [
    {
      icon: "ri-shield-check-line",
      title: "256-bit SSL 加密",
      desc: "全程数据加密传输，支付信息绝对安全",
      color: "text-green-500",
      bg: "bg-green-50",
    },
    {
      icon: "ri-lock-line",
      title: "货款平台托管",
      desc: "买家付款后由平台托管，确认质量后放款",
      color: "text-amber-500",
      bg: "bg-amber-50",
    },
    {
      icon: "ri-refund-2-line",
      title: "7天质量纠纷保障",
      desc: "收货7天内可发起纠纷，平台介入调查",
      color: "text-red-500",
      bg: "bg-red-50",
    },
    {
      icon: "ri-verified-badge-line",
      title: "正品工厂直营",
      desc: "仅认证工厂自有品牌商品，杜绝仿冒",
      color: "text-indigo-500",
      bg: "bg-indigo-50",
    },
  ];

  return (
    <section className="bg-gradient-to-br from-amber-400 via-yellow-400 to-amber-500 py-14">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section header */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 bg-white/40 border border-amber-300 rounded-full px-4 py-1.5 mb-4">
            <i className="ri-shield-check-line text-amber-900 text-sm"></i>
            <span className="text-amber-900 text-xs font-semibold">安全支付认证</span>
          </div>
          <h2 className="text-amber-900 font-bold text-2xl mb-2" style={{ fontFamily: "'Noto Serif SC', serif" }}>
            多种支付方式 · 全程安全保障
          </h2>
          <p className="text-amber-800 text-sm max-w-xl mx-auto">
            皇冠鸿运商城支持信用卡、借记卡、微信支付、支付宝、PayPal 等多种支付方式，货款全程平台托管，让每一笔交易都安心无忧。
          </p>
        </div>

        {/* Payment method icons */}
        <div className="flex items-center justify-center gap-3 flex-wrap mb-10">
          {paymentMethods.map((pm) => (
            <div
              key={pm.label}
              className="flex flex-col items-center gap-1.5 px-4 py-3 bg-white/50 hover:bg-white/80 rounded-xl border border-amber-300/50 min-w-[72px] transition-all hover:-translate-y-0.5 cursor-default"
            >
              <div className="w-8 h-8 flex items-center justify-center">
                <i className={`${pm.icon} ${pm.color} text-2xl`}></i>
              </div>
              <span className="text-amber-900 text-xs font-medium whitespace-nowrap">{pm.label}</span>
            </div>
          ))}
        </div>

        {/* Trust badges */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {trustItems.map((item) => (
            <div
              key={item.title}
              className="flex items-start gap-3 bg-white/40 hover:bg-white/60 rounded-xl p-4 border border-amber-300/40 transition-colors"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-white/60 rounded-lg flex-shrink-0">
                <i className={`${item.icon} ${item.color} text-xl`}></i>
              </div>
              <div>
                <p className="text-amber-900 font-semibold text-sm">{item.title}</p>
                <p className="text-amber-800 text-xs mt-0.5 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom strip */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-xs text-amber-800 flex-wrap">
          {[
            { icon: "ri-global-line", text: "支持全球 200+ 国家和地区" },
            { icon: "ri-exchange-cny-line", text: "多币种自动换算" },
            { icon: "ri-customer-service-2-line", text: "7×24 小时支付客服" },
            { icon: "ri-time-line", text: "秒级到账确认" },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-1.5">
              <i className={`${item.icon} text-amber-700`}></i>
              <span>{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
